/**
 * Environment / build-time config.
 *
 * Vite exposes `import.meta.env.*` for any vars prefixed `VITE_`. We surface
 * them through a single `env` object so the rest of the code base doesn't
 * sprinkle `import.meta.env` literals around (and so tests can mock).
 */

export type Profile = "local" | "dev1" | "qua1" | "prod";

export interface EnvConfig {
  profile: Profile;
  apiBaseUrl: string;
  oktaEnabled: boolean;
  oktaIssuer: string;
  oktaClientId: string;
  oktaRedirectUri: string;
  oktaScopes: string[];
}

const profile = (import.meta.env.VITE_PROFILE ?? "local") as Profile;

export const env: EnvConfig = {
  profile,
  // Empty string means same-origin (CloudFront proxies /v1 -> ALB).
  // Vite dev proxy forwards to http://127.0.0.1:8000 when set blank.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  // Local-dev bypass: FakeAuthService on the backend always accepts.
  oktaEnabled: profile !== "local" && import.meta.env.VITE_OKTA_ENABLED !== "false",
  oktaIssuer: import.meta.env.VITE_OKTA_ISSUER ?? "https://echo.okta.com/oauth2/default",
  oktaClientId: import.meta.env.VITE_OKTA_CLIENT_ID ?? "",
  oktaRedirectUri:
    import.meta.env.VITE_OKTA_REDIRECT_URI ?? `${window.location.origin}/login/callback`,
  oktaScopes: ["openid", "profile", "email"],
};

export const isLocal = env.profile === "local";
export const isProd = env.profile === "prod";
